import { getSum } from "@/common/helpers/utils.helper"

export const campaign = (state) => {
  return state.campaign
}

export const campaigns = (state) => {
  return state.campaigns
}

export const targets = (state) => {
  return state.targets
}

export const targetDetail = (state) => {
  return state.targetDetail
}

export const ruleChains = (state) => {
  return state.ruleChains
}

export const advertisers = (state) => {
  return state.advertisers
}

export const inventory = (state) => {
  return state.inventory
}

export const reports = (state) => {
  return state.reports
}

export const reportStats = (state, getters) => {
  let campaignStats = {
    timePeriod: [],
    impressions: [],
  }

  let stats = getters.reports?.stats?.dailyImpressions

  if (stats && stats.length) {
    for (let i = 0; i < stats.length; i++) {
      campaignStats.timePeriod.push(stats[i].date)

      if (stats[i].impressions !== undefined) {
        campaignStats.impressions.push(stats[i].impressions)
      }
    }
  }

  return campaignStats
}

export const totalImpressions = (state, getters) => {
  const impressions = getters.reports?.stats?.dailyImpressions
  return impressions && impressions.length ? impressions.map((e) => e.impressions).reduce(getSum) : 0
}

export const totalLocationImpressions = (state, getters) => {
  const impressions = getters.reports?.stats?.locationImpressions
  return impressions && impressions.length ? impressions.map((e) => e.impressions).reduce(getSum) : 0
}

export const totalStationImpressions = (state, getters) => {
  const impressions = getters.reports?.stats?.topStations
  return impressions && impressions.length ? impressions.map((e) => e.impressions).reduce(getSum) : 0
}

export const advertisingDetails = (state) => {
  return state.advertisingDetails
}

export const impressionPrice = (state) => {
  // The API value is a price per impression denominated in USD.
  return state.advertisingDetails?.impressionPrice ?? 0.0004
}
